import Cookies from 'js-cookie'
import Flag from "react-flags"
import Button from '../uiLib/Button'


class LanguageSelectingModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalState: false,
      selectedLanguage: null
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.selectLanguage = this.selectLanguage.bind(this)
  }
  componentDidMount() {
    if (!Cookies.get('localizationSelected')) {
      this.setState({ modalState: true })
    }
  }
  componentWillUnmount() {
    Cookies.set('localizationSelected', true, { expires: 365 })
  }
  setLangCookie(lang) {
    const currentLang = Cookies.get('lang')
    if (currentLang === lang) {
      Cookies.set('localizationSelected', true, { expires: 365 })
    } else {
      Cookies.set('lang', lang)
      Cookies.set('localizationSelected', true, { expires: 365 })
    }
    window.location.reload()
  }
  toggleModal() {
    if (!Cookies.get('localizationSelected')) {
      this.setLangCookie('en')
    }
    this.setState({
      modalState: !this.state.modalState
    })
  }
  selectLanguage(lang) {
    this.setState({ selectedLanguage: lang })
    if (lang !== 'ca') {
      this.setLangCookie(lang)
    }
  }

  render() {
    const { t } = this.props
    return (
      <div className={`modal ${this.state.modalState ? `is-active` : null}`}>
        <div className="modal-background" onClick={this.toggleModal} />
        <div className="modal-card lang-modal">
          <div className="modal-card-head">
            <p className="modal-card-title">{t('common:select-default-country')}</p>
            <button className="delete" aria-label="close" onClick={this.toggleModal} />
          </div>
          <div className="modal-card-body">
            <div className="content">
              {
                this.state.selectedLanguage === 'ca' || this.state.selectedLanguage === 'fr' ? (
                  <span className="ma-country-language-select is-clearfix">
                    <a onClick={() => this.selectLanguage('en')}>
                      <Button
                        outlined
                        btType="primary"
                        className="m-l-md">
                        {t('common:english')}
                      </Button>
                    </a>
                    <a onClick={() => this.selectLanguage('fr')}>
                      <Button
                        outlined
                        btType="primary"
                        className="m-l-md">
                        {t('common:french-canadian')}
                      </Button>
                    </a>
                  </span>
                ) : (
                  <span>
                    <a onClick={() => this.selectLanguage('en')}>
                      <Flag name="USA" format="png" pngSize={64} shiny={false} alt="USA Flag"
                        basePath="/static/images/flags" />
                    </a>
                    <a onClick={() => this.selectLanguage('ca')}>
                      <Flag name="CAN" format="png" pngSize={64} shiny={false} alt="Canada Flag"
                        basePath="/static/images/flags" />
                    </a>
                  </span>
                )
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default LanguageSelectingModal



// WEBPACK FOOTER //
// ./components/LanguageSelectingModal/index.js